// Desc: This component is used to display the builder logo in the carousel.
import { useEffect, useRef, useState } from "react";
import "./client.css";

const ClientLogoCarosel = ({ builderData }) => {
  const [data, setData] = useState([]);
  useEffect(() => setData(builderData || []), [builderData]);

  const slideTrackRef = useRef(null);

  useEffect(() => {
    const slideTrack = slideTrackRef.current;
    if (!slideTrack) return;
    const slides = Array.from(slideTrack.children);

    // Clone the first set of slides to the end for seamless scrolling
    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      slideTrack.appendChild(clone);
    });
  }, []);

  return (
    <div className="list" ref={slideTrackRef}>
      {data && data.length > 0 ? (
        data.map((image, index) => (
          <div className="card" key={`${image.id}-${index}`}>
            <a href="/counter-party" rel="noreferrer">
              <img src={image.builder_logo} alt={`Logo ${image.builder_name}`} />
            </a>
          </div>
        ))
      ) : (
        <></>
      )}
    </div>
  );
};
export default ClientLogoCarosel;
